import { MachineDto, ModalService, SimpleMessageService, Tenant, WebAppCommonModule } from '@allbesmart/web-app-common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TenantManagementService } from 'src/app/services/tenant-management.service';
import { MachineDetailsComponent } from '../machine-details/machine-details.component';

@Component({
    selector: 'oaibox-machine-serial-number-update-modal',
    templateUrl: './machine-serial-number-update-modal.component.html',
    styleUrls: ['./machine-serial-number-update-modal.component.css'],
    imports: [WebAppCommonModule, MachineDetailsComponent, ReactiveFormsModule]
})
export class MachineSerialNumberUpdateModalComponent implements OnInit, OnDestroy {

  @Input() tenant?: Tenant;
  @Input() machine?: MachineDto;

  public machineSerialNumberUpdateForm: FormGroup<{
    serialNumber: FormControl<string | null>,
  }>;

  public requestOnGoing: boolean = false;

  private machineSerialNumberUpdateSubscription?: Subscription;

  constructor(
    private tenantManagementService: TenantManagementService,
    private simpleMessageService: SimpleMessageService,
    private modalService: ModalService,
  ) {
    this.machineSerialNumberUpdateForm = new FormGroup({
      serialNumber: new FormControl<string | null>(null, [Validators.required]),
    });
  }

  ngOnInit(): void {
    if (this.machine) {
      this.machineSerialNumberUpdateForm.patchValue({ serialNumber: this.machine.oaiboxSerialNumber });
    } else {
      throw new Error("Machine not found!");
    }
  }

  public save(): void {
    if (this.machineSerialNumberUpdateForm.invalid) return;

    this.machineSerialNumberUpdateSubscription?.unsubscribe();
    if (this.machine && this.tenant) {
      this.requestOnGoing = true;
      this.machineSerialNumberUpdateSubscription = this.tenantManagementService.updateMachineSerialNumber(this.tenant.id, this.machine.id, this.machineSerialNumberUpdateForm.value.serialNumber ?? '')
        .subscribe({
          next: () => {
            this.requestOnGoing = false;
            this.simpleMessageService.showSimpleMessage({
              message: 'Machine serial number updated successfully!',
              icon: 'fa-solid fa-check-double',
              color: 'success',
            });
            this.tenantManagementService.refreshTenants();
            this.modalService.popModal();
          },
          error: () => {
            this.requestOnGoing = false;
            this.simpleMessageService.showSimpleMessage({
              message: 'Machine serial number not updated!',
              icon: 'fa-solid fa-triangle-exclamation',
              color: 'danger',
            });
          }
        });
    }
  }

  public cancel(): void {
    this.modalService.popModal();
  }

  ngOnDestroy(): void {
    this.machineSerialNumberUpdateSubscription?.unsubscribe();
  }
}
